import { useEffect } from "react";
import { faqs } from "@/mocks/gossipData";

const WEBSITE = "https://haoxinwenhua.cn/";

function buildSchema() {
  const schemas: Record<string, unknown>[] = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "吃瓜大全",
      url: WEBSITE,
      inLanguage: "zh-CN",
      description:
        "聚合娱乐综艺、剧集、音乐与网络热议的精华帖与高赞内容，每日更新今日热榜、主编精选与热门推荐合集。",
      potentialAction: {
        "@type": "SearchAction",
        target: `${WEBSITE}?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "吃瓜大全",
      url: WEBSITE,
      logo: `${WEBSITE}logo.png`,
      description: "面向泛娱乐人群的娱乐热点内容聚合推荐平台。",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ];
  return schemas;
}

export default function StructuredData() {
  useEffect(() => {
    const container = document.createElement("div");
    container.style.display = "none";
    for (const schema of buildSchema()) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(schema);
      container.appendChild(script);
    }
    document.head.appendChild(container);
    return () => {
      container.remove();
    };
  }, []);

  return null;
}